import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Logo } from 'next/components/ui';
import NavItem from './NavItem';
import InstallButton from './InstallButton';
import HelpMenu from './HelpMenu';
import SpoofControl from './SpoofControl';
import TrialMeter from './TrialMeter';
import {
  Wrapper,
  Header,
  Scrollable,
  Links,
  Group,
  Separator,
  CallToActions,
} from './styled';

export const Navigation = ({
  accountMeta = {},
  flowsShown,
  installed,
  onGetOverview,
  onSpoof,
  spoofing,
  user = {},
}) => {
  const {
    isTrial,
    isTrialExpired,
    trialLengthDays,
    flowsShownLimit,
    createdAt,
  } = accountMeta;
  const { email, fullname, isAdmin } = user;

  return (
    <Wrapper>
      {isAdmin && <SpoofControl onSubmit={onSpoof} spoofing={spoofing} />}

      <Header>
        <Link to="/">
          <Logo />
        </Link>
      </Header>

      <Separator />

      <Scrollable>
        <Links>
          <Group>
            <NavItem exact icon="th-list" label="Overview" to="/" />
            <NavItem icon="map" label="Flows" to="/flows" />
            <NavItem icon="check-circle" label="Checklists" to="/checklists" />
            <NavItem icon="comment-alt" label="NPS" to="/nps" />
          </Group>

          <Separator />

          <Group>
            <NavItem
              icon="chart-bar"
              label="Events Explorer"
              to="/insights/explorer"
            />
            <NavItem icon="th" label="Dashboard" to="/insights/charts" />
          </Group>

          <Separator />

          <Group>
            <NavItem icon="palette" label="Themes" to="/themes" />
            <NavItem icon="users" label="Segments" to="/segments" />
            <NavItem icon="bullseye" label="Goals" to="/goals" />
          </Group>

          <Separator />

          <Group>
            <HelpMenu user={user} />
          </Group>
        </Links>

        <CallToActions>
          {installed === false && <InstallButton />}

          {isTrial && (
            <TrialMeter
              createdAt={createdAt}
              days={trialLengthDays}
              email={email}
              expired={isTrialExpired}
              limit={flowsShownLimit}
              name={fullname}
              onLoad={onGetOverview}
              shown={flowsShown}
            />
          )}
        </CallToActions>
      </Scrollable>

      <Separator />

      {/* TODO: Add account menu */}
      {/* XXX: Temporary link to account switcher */}
      <Group>
        <NavItem icon="exclamation-triangle" label="Accounts" to="/accounts" />
      </Group>
    </Wrapper>
  );
};

Navigation.propTypes = {
  installed: PropTypes.bool,
  // These are temporary props until we use our own redux store
  // Future names does not need to follow these,
  // Those are mainly to avoid passed lots of props
  onSpoof: PropTypes.func,
  spoofing: PropTypes.bool,
  user: PropTypes.shape({
    email: PropTypes.string,
    fullname: PropTypes.string,
    isAdmin: PropTypes.bool,
  }),
  accountMeta: PropTypes.shape({
    createdAt: PropTypes.number,
    flowsShownLimit: PropTypes.number,
    isTrial: PropTypes.bool,
    isTrialExpired: PropTypes.bool,
    trialLengthDays: PropTypes.number,
  }),
  flowsShown: PropTypes.number,
  onGetOverview: PropTypes.func,
};

export default Navigation;
